const E = ["en"];
const c = (code, name, langs = E) => ({ code, name, langs });

export const AREAS = [
  {
    id: "europe",
    name: "Europe",
    countries: [
      c("AL", "Albania", ["en", "it"]),
      c("AD", "Andorra", ["es"]),
      c("AT", "Austria", ["de"]),
      c("BY", "Belarus", ["ru", "en"]),
      c("BE", "Belgium", ["nl", "fr"]),
      c("BA", "Bosnia and Herzegovina"),
      c("BG", "Bulgaria", ["en", "ru"]),
      c("HR", "Croatia", ["en", "it"]),
      c("CY", "Cyprus", ["en", "tr"]),
      c("CZ", "Czechia", ["cs", "en"]),
      c("DK", "Denmark"),
      c("EE", "Estonia", ["en", "de", "ru"]),
      c("FI", "Finland", ["en", "ru"]),
      c("FR", "France", ["fr"]),
      c("DE", "Germany", ["de"]),
      c("GR", "Greece"),
      c("HU", "Hungary", ["hu", "en"]),
      c("IS", "Iceland"),
      c("IE", "Ireland"),
      c("IT", "Italy", ["it"]),
      c("XK", "Kosovo"),
      c("LV", "Latvia", ["en", "ru"]),
      c("LI", "Liechtenstein", ["de", "en"]),
      c("LT", "Lithuania", ["en", "ru"]),
      c("LU", "Luxembourg", ["fr"]),
      c("MT", "Malta", ["en", "it"]),
      c("MD", "Moldova", ["ro", "en", "ru"]),
      c("MC", "Monaco", ["fr"]),
      c("ME", "Montenegro"),
      c("NL", "Netherlands", ["nl", "en", "de"]),
      c("MK", "North Macedonia"),
      c("NO", "Norway"),
      c("PL", "Poland", ["pl", "en", "de"]),
      c("PT", "Portugal", ["pt"]),
      c("RO", "Romania", ["ro", "en", "it"]),
      c("RU", "Russia", ["ru", "en"]),
      c("SM", "San Marino", ["it", "en"]),
      c("RS", "Serbia", ["en", "it"]),
      c("SK", "Slovakia", ["cs", "en"]),
      c("SI", "Slovenia", ["en", "de", "it"]),
      c("ES", "Spain", ["es"]),
      c("SE", "Sweden", ["sv", "en"]),
      c("CH", "Switzerland", ["de", "fr", "it", "en"]),
      c("TR", "Turkey", ["tr", "en"]),
      c("UA", "Ukraine", ["en", "ru"]),
      c("GB", "United Kingdom"),
    ],
  },
  {
    id: "north-america",
    name: "North America",
    countries: [
      c("CA", "Canada", ["en", "fr"]),
      c("MX", "Mexico", ["es"]),
      c("US", "United States", ["en", "es"]),
    ],
  },
  {
    id: "south-america",
    name: "Central & South America",
    countries: [
      c("AG", "Antigua and Barbuda", ["en", "es"]),
      c("AR", "Argentina", ["es"]),
      c("BS", "Bahamas"),
      c("BB", "Barbados", ["en", "es"]),
      c("BZ", "Belize", ["en", "es"]),
      c("BO", "Bolivia", ["es"]),
      c("BR", "Brazil", ["pt", "en"]),
      c("CL", "Chile", ["es"]),
      c("CO", "Colombia", ["es"]),
      c("CR", "Costa Rica", ["es"]),
      c("CU", "Cuba", ["es"]),
      c("DM", "Dominica"),
      c("DO", "Dominican Republic", ["es"]),
      c("EC", "Ecuador", ["es"]),
      c("SV", "El Salvador", ["es"]),
      c("GD", "Grenada"),
      c("GT", "Guatemala", ["es"]),
      c("GY", "Guyana"),
      c("HT", "Haiti", ["fr", "en"]),
      c("HN", "Honduras", ["es"]),
      c("JM", "Jamaica"),
      c("NI", "Nicaragua", ["es"]),
      c("PA", "Panama", ["es"]),
      c("PY", "Paraguay", ["es"]),
      c("PE", "Peru", ["es"]),
      c("KN", "Saint Kitts and Nevis"),
      c("LC", "Saint Lucia"),
      c("VC", "Saint Vincent and the Grenadines"),
      c("SR", "Suriname"),
      c("TT", "Trinidad and Tobago"),
      c("UY", "Uruguay", ["es"]),
      c("VE", "Venezuela", ["es"]),
    ],
  },
  {
    id: "middle-east-africa",
    name: "Middle East & Africa",
    countries: [
      c("DZ", "Algeria", ["ar", "fr", "en"]),
      c("AO", "Angola", ["pt", "en"]),
      c("BH", "Bahrain", ["ar", "en"]),
      c("BJ", "Benin", ["fr"]),
      c("BW", "Botswana"),
      c("BF", "Burkina Faso", ["fr"]),
      c("BI", "Burundi", ["fr", "en"]),
      c("CV", "Cabo Verde"),
      c("CM", "Cameroon", ["fr", "en"]),
      c("CF", "Central African Republic"),
      c("TD", "Chad", ["fr", "ar", "en"]),
      c("KM", "Comoros", ["ar", "fr", "en"]),
      c("CG", "Congo (Brazzaville)", ["fr", "en"]),
      c("CD", "Congo (DRC)", ["fr", "en"]),
      c("CI", "Côte d'Ivoire", ["fr", "en"]),
      c("DJ", "Djibouti", ["fr", "ar", "en"]),
      c("EG", "Egypt", ["ar", "en", "fr"]),
      c("GQ", "Equatorial Guinea", ["en", "pt"]),
      c("ER", "Eritrea", ["ar", "en", "it"]),
      c("SZ", "Eswatini"),
      c("ET", "Ethiopia", ["en", "it"]),
      c("GA", "Gabon", ["fr", "en"]),
      c("GM", "Gambia"),
      c("GH", "Ghana"),
      c("GN", "Guinea", ["fr", "en"]),
      c("GW", "Guinea-Bissau", ["en", "pt"]),
      c("IR", "Iran"),
      c("IQ", "Iraq", ["ar", "en"]),
      c("IL", "Israel", ["en", "ar"]),
      c("JO", "Jordan", ["ar", "en"]),
      c("KE", "Kenya"),
      c("KW", "Kuwait", ["ar", "en"]),
      c("LB", "Lebanon", ["ar", "en"]),
      c("LS", "Lesotho"),
      c("LR", "Liberia"),
      c("LY", "Libya", ["en", "it"]),
      c("MG", "Madagascar", ["fr", "en"]),
      c("MW", "Malawi"),
      c("ML", "Mali", ["fr", "en"]),
      c("MR", "Mauritania", ["ar", "en"]),
      c("MU", "Mauritius", ["fr"]),
      c("MA", "Morocco", ["ar", "fr", "en"]),
      c("MZ", "Mozambique", ["pt", "en"]),
      c("NA", "Namibia"),
      c("NE", "Niger", ["fr", "en"]),
      c("NG", "Nigeria"),
      c("OM", "Oman", ["ar", "en"]),
      c("PS", "Palestine", ["ar", "en"]),
      c("QA", "Qatar", ["ar", "en"]),
      c("RW", "Rwanda", ["en", "fr"]),
      c("ST", "São Tomé and Príncipe", ["pt", "en"]),
      c("SA", "Saudi Arabia", ["ar", "en"]),
      c("SN", "Senegal", ["fr", "en"]),
      c("SC", "Seychelles", ["en", "fr"]),
      c("SL", "Sierra Leone"),
      c("SO", "Somalia", ["ar", "en", "it"]),
      c("ZA", "South Africa"),
      c("SS", "South Sudan"),
      c("SD", "Sudan", ["ar", "en"]),
      c("SY", "Syria", ["ar", "en", "it"]),
      c("TZ", "Tanzania"),
      c("TG", "Togo", ["fr"]),
      c("TN", "Tunisia", ["ar", "fr", "en"]),
      c("AE", "United Arab Emirates", ["ar", "en"]),
      c("UG", "Uganda"),
      c("YE", "Yemen", ["ar", "en"]),
      c("ZM", "Zambia"),
      c("ZW", "Zimbabwe"),
    ],
  },
  {
    id: "asia",
    name: "Asia",
    countries: [
      c("AF", "Afghanistan"),
      c("AM", "Armenia", ["ru", "en"]),
      c("AZ", "Azerbaijan", ["en", "ru"]),
      c("BD", "Bangladesh"),
      c("BT", "Bhutan"),
      c("BN", "Brunei"),
      c("KH", "Cambodia"),
      c("CN", "China", ["zh", "en"]),
      c("GE", "Georgia", ["en", "ru"]),
      c("IN", "India"),
      c("ID", "Indonesia", ["id", "en"]),
      c("JP", "Japan", ["ja", "en"]),
      c("KZ", "Kazakhstan", ["ru", "en"]),
      c("KG", "Kyrgyzstan", ["ru", "en"]),
      c("LA", "Laos"),
      c("MY", "Malaysia"),
      c("MV", "Maldives"),
      c("MN", "Mongolia"),
      c("MM", "Myanmar"),
      c("NP", "Nepal"),
      c("PK", "Pakistan"),
      c("PH", "Philippines"),
      c("SG", "Singapore", ["en", "zh", "ja"]),
      c("KR", "South Korea"),
      c("LK", "Sri Lanka"),
      c("TW", "Taiwan", ["zh", "en"]),
      c("TJ", "Tajikistan", ["ru", "en"]),
      c("TH", "Thailand"),
      c("TL", "Timor-Leste", ["pt", "en"]),
      c("TM", "Turkmenistan", ["ru", "en"]),
      c("UZ", "Uzbekistan", ["ru", "en"]),
      c("VN", "Vietnam"),
    ],
  },
  {
    id: "oceania",
    name: "Oceania",
    countries: [
      c("AU", "Australia"),
      c("FJ", "Fiji"),
      c("KI", "Kiribati"),
      c("MH", "Marshall Islands"),
      c("FM", "Micronesia"),
      c("NR", "Nauru"),
      c("NZ", "New Zealand"),
      c("PW", "Palau"),
      c("PG", "Papua New Guinea"),
      c("WS", "Samoa"),
      c("SB", "Solomon Islands"),
      c("TO", "Tonga"),
      c("TV", "Tuvalu"),
      c("VU", "Vanuatu"),
    ],
  },
];

export const OFFICES = {
  europe: {
    sk: "eu",
    label: "Europe Office",
    company: "VANROCK Europe",
    subtitle: "European Sales & Dealer Development Office",
    address: "Marcel-Breuer-Str. 15, Munich, Bayern 80807, Germany",
    phone: "+49 89 208036404",
    email: "sales.europe@vanrocktracksolutions.com",
    hours: "Mon–Fri 08:00–18:00 (CET)",
    currency: "EUR",
    whatsapp: "",
  },
  "north-america": {
    sk: "am",
    label: "North America Office",
    company: "VANROCK Americas",
    subtitle: "Americas Sales & Dealer Development Office",
    address: "1751 River Run, Suite 200, Fort Worth, Texas 76107, USA",
    phone: "+1 682-332-5004",
    email: "sales.americas@vanrocktracksolutions.com",
    hours: "Mon–Fri 08:00–17:00 (CST)",
    currency: "USD",
    whatsapp: "",
  },
  "south-america": {
    label: "Latin America Office",
    company: "VANROCK América Latina Ltda.",
    address: "Av. Industrial 1200, São Paulo, SP, Brazil",
    phone: "+55 11 0000 0000",
    email: "latam@vanrocktrack.com",
    hours: "Mon–Fri 08:00–17:00 (BRT)",
    currency: "USD",
    whatsapp: "+55 11 90000 0000",
  },
  "middle-east-africa": {
    label: "Middle East & Africa Office",
    company: "VANROCK Middle East FZE",
    address: "Jebel Ali Free Zone, Dubai, UAE",
    phone: "+971 4 000 0000",
    email: "mea@vanrocktrack.com",
    hours: "Mon–Fri 08:00–17:00 (GST)",
    currency: "USD",
    whatsapp: "+971 50 000 0000",
  },
  asia: {
    label: "Asia Pacific Office",
    company: "VANROCK Asia Pacific Pte. Ltd.",
    address: "10 Tuas Avenue, Singapore 639000",
    phone: "+65 6000 0000",
    email: "asia@vanrocktrack.com",
    hours: "Mon–Fri 09:00–18:00 (SGT)",
    currency: "USD",
    whatsapp: "+65 8000 0000",
  },
  oceania: {
    sk: "au",
    label: "Oceania Office",
    company: "VANROCK Australia",
    subtitle: "Australian Sales & Dealer Development Office",
    address: "14 Mason St, Dandenong, Victoria 3175, Australia",
    phone: "+61 3 7036 9041",
    email: "sales.australia@vanrocktracksolutions.com",
    hours: "Mon–Fri 08:00–17:00 (AEST)",
    currency: "AUD",
    whatsapp: "",
  },
  india: {
    label: "India Office",
    company: "VANROCK Heavy Industry",
    address: "Budhewal Road, Jandiali, Ludhiana, Punjab - 141112, India",
    phone: "+91 86999 48132",
    email: "sales.india@vanrocktracksolutions.com",
    hours: "Mon–Fri 09:00–18:00 (IST)",
    currency: "INR",
    whatsapp: "+91 86999 48132",
  },
};

const AREA_OFFICE = { europe: "europe", "north-america": "north-america", oceania: "oceania" };
const INDIA_OFFICE_COUNTRIES = ["Turkey"];

export const officeFor = (countryName) => {
  if (INDIA_OFFICE_COUNTRIES.includes(countryName)) return OFFICES.india;
  for (const a of AREAS) {
    if (a.countries.some((x) => x.name === countryName)) {
      const k = AREA_OFFICE[a.id];
      return (k && OFFICES[k]) || OFFICES.india;
    }
  }
  return OFFICES.india;
};

export const US_HQ = {
  company: "VANROCK Industries LLC",
  address: "30 N Gould St #67190, Sheridan, WY 82801, United States",
  phone: "+1 214-493-2667",
  email: "contact@vanrocktracksolutions.com",
};

export const FOOTER_OFFICES = [
  {
    key: "usa", ...OFFICES["north-america"],
    sk: "ushq", company: US_HQ.company, subtitle: "", address: US_HQ.address, phone: US_HQ.phone, email: US_HQ.email,
    sub: { sk: "am", company: OFFICES["north-america"].company, subtitle: OFFICES["north-america"].subtitle, address: OFFICES["north-america"].address, phone: OFFICES["north-america"].phone, email: OFFICES["north-america"].email },
  },
  { key: "europe", ...OFFICES.europe },
  { key: "australia", ...OFFICES.oceania },
  { key: "india", ...OFFICES.india },
];

export const NATIVE_NAMES = {
  AL: "Shqipëria",
  AT: "Österreich",
  BY: "Беларусь",
  BE: "België / Belgique",
  BA: "Bosna i Hercegovina",
  BG: "България",
  HR: "Hrvatska",
  CY: "Κύπρος / Kıbrıs",
  CZ: "Česko",
  DK: "Danmark",
  EE: "Eesti",
  FI: "Suomi",
  DE: "Deutschland",
  GR: "Ελλάδα",
  HU: "Magyarország",
  IS: "Ísland",
  IE: "Ireland / Éire",
  IT: "Italia",
  XK: "Kosova",
  LV: "Latvija",
  LT: "Lietuva",
  ME: "Crna Gora",
  NL: "Nederland",
  MK: "Северна Македонија",
  NO: "Norge",
  PL: "Polska",
  RO: "România",
  RU: "Россия",
  RS: "Srbija",
  SK: "Slovensko",
  SI: "Slovenija",
  ES: "España",
  SE: "Sverige",
  CH: "Schweiz / Suisse",
  TR: "Türkiye",
  UA: "Україна",
  MX: "México",
  BR: "Brasil",
  DO: "República Dominicana",
  HT: "Haïti",
  PA: "Panamá",
  PE: "Perú",
  DZ: "الجزائر",
  BH: "البحرين",
  BJ: "Bénin",
  CM: "Cameroun",
  TD: "Tchad",
  KM: "Comores",
  CD: "RD Congo",
  EG: "مصر",
  GQ: "Guinea Ecuatorial",
  GN: "Guinée",
  GW: "Guiné-Bissau",
  IR: "ایران",
  IQ: "العراق",
  IL: "ישראל",
  JO: "الأردن",
  KW: "الكويت",
  LB: "لبنان",
  LY: "ليبيا",
  MG: "Madagasikara",
  MR: "موريتانيا",
  MU: "Maurice",
  MA: "المغرب",
  MZ: "Moçambique",
  OM: "عُمان",
  PS: "فلسطين",
  QA: "قطر",
  ST: "São Tomé e Príncipe",
  SA: "السعودية",
  SN: "Sénégal",
  SO: "Soomaaliya",
  SD: "السودان",
  SY: "سوريا",
  TN: "تونس",
  AE: "الإمارات",
  YE: "اليمن",
  AF: "افغانستان",
  AM: "Հայաստան",
  AZ: "Azərbaycan",
  BD: "বাংলাদেশ",
  KH: "កម្ពុជា",
  CN: "中国",
  GE: "საქართველო",
  IN: "भारत / India",
  JP: "日本",
  KZ: "Қазақстан",
  KG: "Кыргызстан",
  LA: "ລາວ / Laos",
  MN: "Монгол",
  MM: "မြန်မာ",
  NP: "नेपाल",
  PK: "پاکستان",
  PH: "Pilipinas",
  KR: "대한민국",
  TW: "台灣",
  TJ: "Тоҷикистон",
  TH: "ไทย",
  TM: "Türkmenistan",
  UZ: "Oʻzbekiston",
  VN: "Việt Nam",
  WS: "Sāmoa",
};

export const findCountry = (code) => {
  for (const a of AREAS) {
    const cc = a.countries.find((x) => x.code === code);
    if (cc) return { area: a, country: cc };
  }
  return null;
};

export const detectLocale = () => {
  const nav = navigator.language || "en";
  const regionPart = nav.split("-")[1]?.toUpperCase();
  const langPart = nav.split("-")[0].toLowerCase();
  let hit = regionPart ? findCountry(regionPart) : null;
  if (!hit) {
    const byLang = {
      de: "DE",
      fr: "FR",
      es: "ES",
      ro: "RO",
      it: "IT",
      pt: "PT",
      nl: "NL",
      pl: "PL",
      tr: "TR",
      ru: "RU",
      ar: "SA",
      zh: "CN",
      ja: "JP",
      sv: "SE",
      cs: "CZ",
      hu: "HU",
      id: "ID",
    }[langPart];
    hit = (byLang && findCountry(byLang)) || findCountry("GB");
  }
  const lang = hit.country.langs.includes(langPart)
    ? langPart
    : hit.country.langs[0];
  return { areaId: hit.area.id, countryCode: hit.country.code, lang };
};
